import { getRemoteValueEnv } from "../setup";
import PropTypes from "prop-types";

// Não deve arredondar as taxas
// Deve truncar as taxas para 2 casas decimais
const setTwoDecimalPlaces = (number) => {
  const truncated = Math.trunc(number * 100) / 100;
  return truncated.toFixed(2).replace(".", ",");
};

const getFees = (plano) => {
  // Verificar se plano existe e tem pelo menos uma das propriedades necessárias
  if (
    !plano ||
    (plano.planoTaxaAdmMensal === undefined &&
      plano.planoTaxaAdmTotal === undefined) ||
    (plano.planoTaxaAdmMensal === null && plano.planoTaxaAdmTotal === null)
  ) {
    return {
      text: "Taxa:",
      value: "Não disponível",
    };
  }

  const isMonthlyFees = getRemoteValueEnv(
    "isMonthlyFees_dev",
    "isMonthlyFees_prod",
  ).asBoolean();

  if (isMonthlyFees) {
    const value = parseFloat(plano.planoTaxaAdmMensal);
    return {
      text: "Taxa mensal:",
      value: isNaN(value) ? "Não disponível" : `${setTwoDecimalPlaces(value)}%`,
    };
  }

  const value = parseFloat(plano.planoTaxaAdmTotal);
  return {
    text: "Taxa:",
    value: isNaN(value) ? "Não disponível" : `${setTwoDecimalPlaces(value)}%`,
  };
};

getFees.propTypes = {
  plano: PropTypes.oneOfType([
    PropTypes.shape({
      planoTaxaAdmMensal: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      planoTaxaAdmTotal: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    }),
    PropTypes.oneOf([null, undefined]),
  ]),
};

export default getFees;
